import React from 'react';
import { LinearProgress, Stack, Typography } from '@mui/material';
import { isUserImportDone, useGetUserImportQuery } from '../../api/userImportsApi';

/** A user import's progress (rows done out of the file's total), until it's done. */
export const UserImportProgress = ({ importId }) => {
	const { data: userImport } = useGetUserImportQuery(importId);
	const { total, processed } = userImport;

	if (isUserImportDone(userImport)) {
		return null;
	}

	return (
		<Stack spacing={0.5}>
			<LinearProgress variant='determinate' value={total ? (processed / total) * 100 : 0} />
			<Typography variant='body2' color='text.secondary'>
				{`${processed} of ${total} rows done`}
			</Typography>
		</Stack>
	);
};
